import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { applyTextSize, storedTextSize } from "./lib/text-size";
import { installExternalLinkBridge } from "./lib/desktop";

// The text-size preset goes on <html> before the first paint: a reload never
// flashes the small size first, and the sign-in screen is covered too.
applyTextSize(storedTextSize());

// Desktop shell only (a no-op in a browser): outbound links go to the Mac's default
// browser and PDF previews to its viewer — WKWebView otherwise swallows both.
installExternalLinkBridge();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
